export default {
  en: {
    show_all: 'Show all chats',
    unread_muted_note: {
      one: 'You have unread messages in one muted chat',
      other: 'You have unread messages in %{count} muted chats',
    },
    mark_all_as_read: 'Mark all as read',
    back: 'Back',
    new_chat: 'New chat',
  },
};
